import { useState, useEffect } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetOrganizationPermissionSchema = () => {
  const [
    organizationPermissionSchema,
    setOrganizationPermissionSchema,
  ] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrganizationPermissionSchema = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await RolesApi.getOrganizationPermissionSchema();
        setOrganizationPermissionSchema(data);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            'Failed to fetch organization permission schema',
        );
        console.error('Error fetching organization permission schema:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizationPermissionSchema();
  }, []);

  return {
    organizationPermissionSchema,
    loading,
    error,
  };
};
